<template>
	<UIShModal class="modal">
		<div class="main">
			<UIShIcon
				role="button"
				aria-label="close"
				name="x-close"
				class="close"
				@click="$emit('cancel')"
			/>

			<b class="title">Получите расчет</b>
			<p class="description">
				Оставьте заявку, наш менеджер свяжется с вами в ближайшее время
			</p>

			<form @submit.prevent>
				<UIShInputText
					required
					lg
					:xl="1920"
					name="name"
					label="Имя"
					v-model="nameField.value.value"
					:error="nameField.errorMessage.value"
				/>

				<UIShInputText
					required
					lg
					:xl="1920"
					name="phone"
					label="Телефон"
					mask="+7(###) ###-##-##"
					v-model="phoneField.value.value"
					:error="phoneField.errorMessage.value"
				/>

				<UIShInputText
					required
					lg
					:xl="1920"
					name="email"
					label="Email"
					v-model="emailField.value.value"
					:error="emailField.errorMessage.value"
				/>

				<UIShCheckbox
					label="Я соглашаюсь с Политикой конфиденциальности"
					v-model="checkField.value.value"
					lg
					xl1440
				/>

				<slot />

				<UIShButton
					type="submit"
					label="Отправить"
					fill
					md
					:xl="1920"
					:disabled="!canSubmit || isLoading"
					@click.prevent="onSubmit"
				/>
			</form>
		</div>
	</UIShModal>
</template>

<script setup lang="ts">
import { type FeedbackData } from '@/common/types';

const $emit = defineEmits<{
	(e: 'submit'): void;
	(e: 'cancel'): void;
}>();

const model = defineModel<Partial<FeedbackData>>({
	required: false,
	default: {}
});

const { isLoading } = useLoadingIndicator();

const {
	nameField,
	phoneField,
	emailField,
	checkField,
	canSubmit,
	handleSubmit
} = useFeedbackForm();

watchEffect(() => {
	model.value.name = nameField.value.value;
	model.value.phone = phoneField.value.value;
	model.value.email = emailField.value.value;
});

const onSubmit = handleSubmit(() => {
	$emit('submit');
});
</script>

<style lang="scss" scoped>
.modal {
	::v-deep(.modal-wrapper) {
		align-items: flex-end;
	}

	::v-deep(.modal-content) {
		width: 100%;
	}
}

.main {
	width: 100%;
	position: relative;
	padding: 1.1111rem;
	padding-top: 1.7778rem;
	color: var(--color-gray950);
	border-top-left-radius: 1.1111rem;
	border-top-right-radius: 1.1111rem;
	background-color: var(--color-white);
}

.close {
	cursor: pointer;
	position: absolute;
	top: 0.6667rem;
	right: 0.6667rem;
	color: var(--color-gray500);
}

b {
	display: block;
	text-align: center;
	@include useFont(dxsb);
	text-transform: uppercase;
}

.description {
	text-align: center;
	@include useFont(tmdm);
	color: var(--color-gray600);
	margin-top: 0.222rem;
}

form {
	display: flex;
	flex-direction: column;
	gap: 0.889rem;
	margin-top: 1.778rem;
}

@include screen768 {
	.modal {
		::v-deep(.modal-wrapper) {
			align-items: center;
		}

		::v-deep(.modal-content) {
			width: auto;
		}
	}

	.main {
		width: 27.778rem;
		padding: 1.7778rem;
		border-radius: 1.1111rem;
	}

	b {
		@include useFont(dsmb);
	}

	p {
		@include useFont(tlgm);
		margin-top: 0.667rem;
	}

	form {
		gap: 1.111rem;
	}
}
</style>
